module.exports = __webpack_public_path__ + "static/media/flash.21207afa.webp";